import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const SoftValidationWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "soft-validation-wrapper-styled",
})`
  margin-top: 20px;
`;

export const SoftValidationListStyled = styled.ul.attrs<IStyledAttributes>({
  "data-e2e": "soft-validation-list-styled",
})`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-inline-start: 20px;
  margin-top: 6px;

  .saved {
    color: ${rydeColors.green};
  }
`;
